{
  "CHAT_LIST": {
    "LOADING": "உரையாடல்களைப் பெறுகிறது",
    "LOAD_MORE_CONVERSATIONS": "மேலும் உரையாடல்களை ஏற்றவும்",
    "EOF": "எல்லா உரையாடல்களும் ஏற்றப்பட்டன",
    "LIST": {
      "404": "இந்த குழுவில் செயலில் உள்ள உரையாடல்கள் எதுவும் இல்லை."
    },
    "FAILED_TO_SEND": "Failed to send",
    "TAB_HEADING": "உரையாடல்கள்",
    "MENTION_HEADING": "Mentions",
    "UNATTENDED_HEADING": "Unattended",
    "SEARCH": {
      "INPUT": "நபர்கள், அரட்டைகள், சேமித்த பதில்களை தேட .."
    },
    "FILTER_ALL": "எல்லாம்",
    "ASSIGNEE_TYPE_TABS": {
      "me": "என்னுடைய",
      "unassigned": "ஒதுக்கப்படாதது",
      "all": "எல்லாம்"
    },
    "CHAT_STATUS_FILTER_ITEMS": {
      "open": {
        "TEXT": "திற"
      },
      "resolved": {
        "TEXT": "தீர்க்கப்பட்டது"
      },
      "pending": {
        "TEXT": "Pending"
      },
      "snoozed": {
        "TEXT": "Snoozed"
      },
      "all": {
        "TEXT": "எல்லாம்"
      }
    },
    "VIEW_FILTER": "காண்க",
    "SORT_TOOLTIP_LABEL": "Sort conversations",
    "CHAT_SORT": {
      "STATUS": "நிலை",
      "ORDER_BY": "Order by"
    },
    "CHAT_TIME_STAMP": {
      "CREATED": {
        "LATEST": "Created",
        "OLDEST": "Created at:"
      },
      "LAST_ACTIVITY": {
        "NOT_ACTIVE": "Last activity:",
        "ACTIVE": "Last activity"
      }
    },
    "SORT_ORDER_ITEMS": {
      "last_activity_at_asc": {
        "TEXT": "Last activity: Oldest first"
      },
      "last_activity_at_desc": {
        "TEXT": "Last activity: Newest first"
      },
      "created_at_desc": {
        "TEXT": "Created at: Newest first"
      },
      "created_at_asc": {
        "TEXT": "Created at: Oldest first"
      },
      "priority_desc": {
        "TEXT": "Priority: Highest first"
      },
      "priority_asc": {
        "TEXT": "Priority: Lowest first"
      },
      "waiting_since_asc": {
        "TEXT": "Pending Response: Longest first"
      },
      "waiting_since_desc": {
        "TEXT": "Pending Response: Shortest first"
      },
      "priority_desc_created_at_asc": {
        "TEXT": "Priority: Highest first, Created: Oldest first"
      }
    },
    "ATTACHMENTS": {
      "image": {
        "CONTENT": "பட செய்தி"
      },
      "audio": {
        "CONTENT": "ஆடியோ செய்தி"
      },
      "video": {
        "CONTENT": "வீடியோ செய்தி"
      },
      "file": {
        "CONTENT": "பைல் இணைப்புகள்"
      },
      "location": {
        "CONTENT": "இருப்பிடம்"
      },
      "ig_reel": {
        "CONTENT": "Instagram Reel"
      },
      "fallback": {
        "CONTENT": "ஒரு URL ஐப் பகிர்ந்துள்ளார்"
      },
      "contact": {
        "CONTENT": "Shared contact"
      },
      "embed": {
        "CONTENT": "Embedded content"
      }
    },
    "CHAT_SORT_BY_FILTER": {
      "TITLE": "Sort conversation",
      "DROPDOWN_TITLE": "Sort by",
      "ITEMS": {
        "LATEST": {
          "NAME": "Last activity at",
          "LABEL": "Last activity"
        },
        "CREATED_AT": {
          "NAME": "Created at",
          "LABEL": "Created at"
        },
        "LAST_USER_MESSAGE_AT": {
          "NAME": "Last user message at",
          "LABEL": "Last message"
        }
      }
    },
    "RECEIVED_VIA_EMAIL": "Received via email",
    "VIEW_TWEET_IN_TWITTER": "View tweet in Twitter",
    "REPLY_TO_TWEET": "Reply to this tweet",
    "LINK_TO_STORY": "Go to instagram story",
    "SENT": "Sent successfully",
    "READ": "Read successfully",
    "DELIVERED": "Delivered successfully",
    "NO_MESSAGES": "No Messages",
    "NO_CONTENT": "No content available",
    "HIDE_QUOTED_TEXT": "Hide Quoted Text",
    "SHOW_QUOTED_TEXT": "Show Quoted Text",
    "MESSAGE_READ": "Read",
    "SENDING": "Sending",
    "UNREAD_COUNT_OVERFLOW": "9+"
  }
}
